import React, { useState } from "react";
import { Card, Typography, Layout, Button } from "antd";
import { FilterOutlined, ReloadOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ReportConfig from "../../../../components/Backoffice/ReportConfig";
import ReportsFilter from "../../../../components/Backoffice/ReportsFilter";
import * as selectors from "../../../../components/Backoffice/ReportsFilter/selectors";
import { useAuth } from "../../../../contexts/auth";

const { Title } = Typography;
const { Header, Content } = Layout;

const ReportsPage = () => {
  const location = useLocation();
  // const auth = useAuth();
  // const user = auth.loggedInUser;
  //  const userRole = user?.role;
  // const companyId = user?.company?._id;

  const locationFilters = location.state?.filters;
  const rawProjects = useSelector(selectors.selectRawProjects);

  const [selectedClients, setSelectedClients] = useState(
    locationFilters?.companyIds || []
  );
  const [selectedProjects, setSelectedProjects] = useState(
    locationFilters?.projectCodeIds || []
  );
  const [selectedCommodities, setSelectedCommodities] = useState(
    locationFilters?.commodityIds || []
  );
  const [selectedStates, setSelectedStates] = useState(
    locationFilters?.stateIds || []
  );
  const [selectedDistricts, setSelectedDistricts] = useState(
    locationFilters?.districtIds || []
  );
  const [selectedSamplers, setSelectedSamplers] = useState(
    locationFilters?.samplerIds || []
  );
  const [selectedLabs, setSelectedLabs] = useState(
    locationFilters?.labIds || []
  );

  const filters = {
    companyIds: selectedClients,
    projectCodeIds: selectedProjects,
    commodityIds: selectedCommodities,
    stateIds: selectedStates,
    districtIds: selectedDistricts,
    samplerIds: selectedSamplers,
    labIds: selectedLabs,
  };

  const handleClientChange = (newSelectedClients) => {
    setSelectedClients(newSelectedClients);

    if (newSelectedClients.length === 0) {
      setSelectedProjects([]);
    } else {
      const validProjects = selectors.getValidProjects(
        selectedProjects,
        newSelectedClients,
        rawProjects
      );
      setSelectedProjects(validProjects);
    }
  };

  const handleProjectChange = (value) => {
    setSelectedProjects(value);
  };
  
  const handleCommodityChange = (value) => {
    setSelectedCommodities(value);
  };
  
  const handleStateChange = (value) => {
    setSelectedStates(value);
  };
  
  const handleDistrictChange = (value) => {
    setSelectedDistricts(value);
  };
  
  const handleSamplerChange = (value) => {
    setSelectedSamplers(value);
  };
  
  const handleLabChange = (value) => {
    setSelectedLabs(value);
  };

  const handleRefresh = () => {
    setSelectedClients([]);
    setSelectedProjects([]);
    setSelectedCommodities([]);
    setSelectedStates([]);
    setSelectedDistricts([]);
    setSelectedSamplers([]);
    setSelectedLabs([]);
  };

  return (
    <Layout style={{ background: "#f9f9f9" }}>
      <Header style={{ background: "#0D9488", padding: "16px 24px", display: "flex", alignItems: "center" }}>
        <Link to="/bo/dashboard" style={{ color: "#fff", marginRight: 16 }}>
          <ArrowLeftOutlined style={{ fontSize: 18 }} />
        </Link>
        <Title level={4} style={{ color: "#fff", margin: 0 }}>
          Reports Module
        </Title>
      </Header>

      <Content style={{ padding: 24 }}>
        <Card
          title={
            <span>
              <FilterOutlined /> Filters
            </span>
          }
          extra={
            <Button 
              onClick={handleRefresh}
              icon={<ReloadOutlined />}
            >
              Reset Filters
            </Button>
          }
        >
          <ReportsFilter
            selectedClients={selectedClients}
            selectedProjects={selectedProjects}
            selectedCommodities={selectedCommodities}
            selectedStates={selectedStates}
            selectedDistricts={selectedDistricts}
            selectedSamplers={selectedSamplers}
            selectedLabs={selectedLabs}
            handleClientChange={handleClientChange}
            handleProjectChange={handleProjectChange}
            handleCommodityChange={handleCommodityChange}
            handleStateChange={handleStateChange}
            handleDistrictChange={handleDistrictChange}
            handleSamplerChange={handleSamplerChange}
            handleLabChange={handleLabChange}
          />
        </Card>

        <Card title="Report Configuration" style={{ marginTop: 24 }}>
          <ReportConfig filters={filters} />
        </Card>
      </Content>
    </Layout>
  );
};

export default ReportsPage;